import { router, Stack } from 'expo-router';
import { useEffect } from 'react';

import CreateReservation from '@/components/create-reservation';
import { useHasOrganization } from '@/core/hooks/use-has-organization';

export default function NewReservationScreen() {
  const { hasOrganization, isPending } = useHasOrganization();

  useEffect(() => {
    if (!isPending && !hasOrganization) {
      router.replace('/partner/reservations');
    }
  }, [isPending, hasOrganization]);

  if (!hasOrganization) {
    return null;
  }

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />

      <CreateReservation />
    </>
  );
}
